(() => {
    const onThemePageLoad = () => {
      customElements.upgrade(document.body);
    };
    if (!window.__bundleBuilderPageLoadHook) {
      window.__bundleBuilderPageLoadHook = true;
      document.addEventListener('theme:page:load', onThemePageLoad);
    }
  
    if (customElements.get('bundle-builder')) return;
  
    const MAIN_TAB_SKIP_SCROLL_IF_VISIBLE_FRAC = 0.7;

    // "Two more ready-made sets…" reads better than "2 more…" in the
    // More-from-Bobbi subheading; anything larger falls back to the digit.
    const SETS_FOOTER_COUNT_WORDS = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six'];

    // Match the CSS transitions on .bundle-set__milestones-fill-seg (transform)
    // and .bundle-set__milestone-dot::before (clip-path).
    const MILESTONE_FILL_MS = 400;
    const MILESTONE_DOT_MS = 180;

    // Longest .bundle-qv exit transition — the gallery is torn down only once
    // the modal has animated out.
    const QV_EXIT_MS = 320;
  
    const mainTabVisibleFracInRow = (btn, root) => {
      const r = btn.getBoundingClientRect();
      const overlap = Math.min(r.right, root.right) - Math.max(r.left, root.left);
      return r.width > 0 ? Math.max(0, overlap) / r.width : 0;
    };
  
    const shopifyRoot = () =>
      typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
  
    const formatBundleJunipReviewCount = (el) => {
      if (!el) return;
      const raw = String(el.textContent || '').trim();
      if (!raw || raw.includes('Reviews')) return;
      const num = raw.replace(/[^\d]/g, '');
      if (!num) return;
      const next = `${num} Reviews`;
      if (raw !== next) el.textContent = next;
    };
  
    const newBundleId = () => {
      if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
      }
      return `bundle-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 11)}`;
    };
  
    class BundleBuilder extends HTMLElement {
      connectedCallback() {
        this.currencyCode = this.dataset.currencyCode || 'USD';
        this.cartTotalCents = Number.parseInt(this.dataset.cartTotal, 10) || 0;
        this._bundleFinalCents = 0;
        this.cartDiscountKey = (this.dataset.cartDiscountKey || '').trim();
        this.cartBundleTitle = (this.dataset.cartBundleTitle || '').trim();
        this.cartBundleUrl = (this.dataset.cartBundleUrl || '').trim();
        this.cartBundleImage = (this.dataset.cartBundleImage || '').trim();
        this.giftTierMin = Number.parseInt(this.dataset.giftTierMin, 10);
        this.giftVariantId = Number.parseInt(this.dataset.giftVariantId, 10);
        this.giftProductTitle = (this.dataset.giftProductTitle || '').trim();
        this.giftVariantTitle = (this.dataset.giftVariantTitle || '').trim();
        this.giftImage = (this.dataset.giftImage || '').trim();
        this._loadTiers();
        this._initQtyIcons();
        this._checkoutLoading = false;
        this.countOutput = this.querySelector('[data-bundle-product-count]');
        this.setsRegion = this.querySelector('[data-bundle-sets]');
        this.mainTabButtons = [...this.querySelectorAll('[data-bundle-main-tab]')];
        this.mainTabsEl = this.querySelector('[data-bundle-main-tabs]');
        this.mainTabsWrap = this.querySelector('[data-bundle-main-tabs-wrap]');
        this.mainTabsScrollNext = this.querySelector('[data-bundle-main-tabs-scroll-next]');
        this.mainTabsScrollPrev = this.querySelector('[data-bundle-main-tabs-scroll-prev]');
        this.viewTabButtons = [...this.querySelectorAll('[data-bundle-view-tab]')];
        this.viewPanels = [...this.querySelectorAll('[data-bundle-view-panel]')];
        this.setTabButtons = [...this.querySelectorAll('[data-bundle-set-tab]')];
        this.setSwiperEl = this.querySelector('[data-bundle-set-swiper]');
        this.setSwiperPaginationEl = this.querySelector('[data-bundle-set-pagination]');
        this.setSwiper = null;
        this.productPanels = [...this.querySelectorAll('.bundle-builder__products-panel')];
        this.titleEl = this.querySelector('[data-bundle-title]');
        this.discountBadgeEl = this.querySelector('[data-bundle-set-discount-badge]');
        this.setBackBtn = this.querySelector('[data-bundle-set-back]');
        this.buildHeadEl = this.querySelector('[data-bundle-head]');
        this.buildViewPanel = this.querySelector('[data-bundle-view-panel="build"]');
        this.setCards = [...this.querySelectorAll('[data-bundle-set-card]')];
        this.setsFooterEl = this.querySelector('[data-bundle-sets-footer]');
        this.setsFooterHeadingEl = this.querySelector('[data-bundle-sets-footer-heading]');
        this.setsFooterSubheadingEl = this.querySelector('[data-bundle-sets-footer-subheading]');
        this.setsFooterButtons = this.setsFooterEl
          ? [...this.setsFooterEl.querySelectorAll('[data-bundle-set-view]')]
          : [];
        this._defaultBuildHeading = this.titleEl ? this.titleEl.textContent.trim() : '';
        this._activeSetPanelId = null;
  
        this.miniSetLines = [];
        this.itemCountEl = this.querySelector('[data-bundle-set-item-count]');
        this.offerTextEls = [...this.querySelectorAll('[data-bundle-set-offer-text]')];
        this.emptyEl = this.querySelector('[data-bundle-set-empty]');
        this.emptyBannerEl = this.querySelector('[data-bundle-set-empty-banner]');
        this.linesListEl = this.querySelector('[data-bundle-set-lines]');
        this.upsellsEl = this.querySelector('[data-bundle-set-upsells]');
        this.upsellsHeadingEl = this.querySelector('[data-bundle-set-upsells-heading]');
        this.upsellCards = [...this.querySelectorAll('[data-bundle-set-upsell-card]')];
        this.strikeEl = this.querySelector('[data-bundle-set-strike]');
        this.discountPillEl = this.querySelector('[data-bundle-set-discount-pill]');
        this.finalEl = this.querySelector('[data-bundle-set-final]');
        this.shippingEl = this.querySelector('[data-bundle-set-shipping]');
        this.checkoutBtn = this.querySelector('[data-bundle-set-checkout-btn]');
        this.shopAllBtn = this.querySelector('[data-bundle-set-shop-all]');
        this.shopAllWrap = this.querySelector('[data-bundle-sets-footer-bottom]');
        if (this.checkoutBtn && !this.checkoutBtn.dataset.checkoutLabel) {
          this.checkoutBtn.dataset.checkoutLabel = this.checkoutBtn.textContent.trim() || 'ADD SET TO CART';
        }
        this.milestoneEls = [...this.querySelectorAll('[data-bundle-set-milestone]')];
        this.milestoneFillSegEls = [...this.querySelectorAll('[data-bundle-set-milestone-fill-seg]')];
        this.miniSetAside = this.querySelector('[data-bundle-set-root]');
        this.mobileBackdrop = this.querySelector('[data-bundle-set-mobile-dismiss]');
        this.quickview = this.querySelector('[data-bundle-quickview]');
        this.quickviewMount = this.querySelector('[data-bundle-quickview-mount]');
        this._qvSourceCard = null;
        this._mobilePeekDismissed = false;
        this._miniSetMobileMq = typeof window.matchMedia !== 'undefined' ? window.matchMedia('(max-width: 1023px)') : null;
        this._onMiniSetMobileMq = () => this._syncMobileMiniSetChrome();
        this._onKeydownMiniSet = (e) => {
          if (e.key !== 'Escape') return;
          if (this.quickview && !this.quickview.hasAttribute('hidden')) {
            this.closeQuickView();
            return;
          }
          if (!this._miniSetMobileMq?.matches) return;
          if (this.getLineQuantitySum() < 1) {
            this._hideMobileMiniSetPeek();
            return;
          }
          if (this.classList.contains('bundle-builder--set-open')) {
            this._closeMobileMiniSetUi();
          } else if (this.classList.contains('bundle-builder--set-peek')) {
            this._hideMobileMiniSetPeek();
          }
        };
  
        this._initJunipReviewFormat();
  
        if (this.mainTabButtons.length === 0 || !this.countOutput) return;
  
        if (this._miniSetMobileMq) {
          this._miniSetMobileMq.addEventListener('change', this._onMiniSetMobileMq);
        }
        document.addEventListener('keydown', this._onKeydownMiniSet);
        this._onPopstate = () => this._applySetFromUrl({ updateUrl: false });
        window.addEventListener('popstate', this._onPopstate);
  
        this._onClick = (pointerEvent) => {
          if (this._handleQuickView(pointerEvent)) return;
          this._handleMiniSetUi(pointerEvent);
          if (this._handleBrowseCards(pointerEvent)) return;
          const viewTabTarget = pointerEvent.target.closest('[data-bundle-view-tab]');
          if (viewTabTarget && this.contains(viewTabTarget)) {
            this.selectView(viewTabTarget.getAttribute('data-bundle-view'));
            return;
          }
          const mainTabTarget = pointerEvent.target.closest('[data-bundle-main-tab]');
          if (mainTabTarget && this.contains(mainTabTarget)) {
            this.selectMainTab(mainTabTarget);
            return;
          }
          const setTabTarget = pointerEvent.target.closest('[data-bundle-set-tab]');
          if (setTabTarget && this.contains(setTabTarget)) {
            pointerEvent.preventDefault();
            this.selectSetTab(setTabTarget);
            return;
          }
          if (pointerEvent.target.closest('[data-bundle-set-shop-all]')) {
            pointerEvent.preventDefault();
            // Same behaviour as the in-grid "Show All" back button: un-pin the
            // curated set and restore the default heading / tabs / full grid,
            // staying in the current view. Then anchor to the builder heading
            // ("Start Customizing Your Set") rather than the top of the page.
            this._resetSetFilterUi();
            this.buildHeadEl?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            return;
          }
        };
        this.addEventListener('click', this._onClick);

        // Warm the quick-view gallery images the moment the user shows intent
        // (hovers / focuses / touches a card's image or "Details" trigger) so
        // the modal's first image is cached before it opens — avoids the
        // image loading in front of the user on slow connections.
        this._qvPrefetched = new WeakSet();
        this._onQvPrefetch = (ev) => {
          const trigger = ev.target.closest?.('[data-bundle-quickview-open]');
          if (trigger && this.contains(trigger)) {
            this._prefetchQuickView(trigger.closest('[data-bundle-browse-card]'));
          }
        };
        this.addEventListener('pointerover', this._onQvPrefetch);
        this.addEventListener('pointerdown', this._onQvPrefetch);
        this.addEventListener('focusin', this._onQvPrefetch);

        this._onQvResize = () => {
          window.clearTimeout(this._qvResizeTimer);
          this._qvResizeTimer = window.setTimeout(() => this._layoutQvSwatches(), 150);
        };
        window.addEventListener('resize', this._onQvResize);
  
        this._syncMainTabsScrollHint = () => {
          if (!this.mainTabsEl || !this.mainTabsWrap || !this.mainTabsScrollNext || !this.mainTabsScrollPrev) return;
          if (typeof window.matchMedia === 'undefined' || !window.matchMedia('(max-width: 768px)').matches) {
            this.mainTabsWrap.classList.remove(
              'bundle-builder__main-tabs-wrap--show-next',
              'bundle-builder__main-tabs-wrap--show-prev',
            );
            return;
          }
          const row = this.mainTabsEl;
          const tabs = this.mainTabButtons;
          if (tabs.length === 0) return;
          const canScroll = row.scrollWidth > row.clientWidth + 1;
          const root = row.getBoundingClientRect();
          const eps = 6;
          const firstLeft = tabs[0].getBoundingClientRect().left;
          const lastRight = tabs[tabs.length - 1].getBoundingClientRect().right;
          const startInView = firstLeft >= root.left - eps;
          const endInView = lastRight <= root.right + eps;
          this.mainTabsWrap.classList.toggle('bundle-builder__main-tabs-wrap--show-prev', canScroll && !startInView);
          this.mainTabsWrap.classList.toggle('bundle-builder__main-tabs-wrap--show-next', canScroll && !endInView);
        };
        this._onMainTabsScrollNextClick = (pointerEvent) => {
          pointerEvent.preventDefault();
          pointerEvent.stopPropagation();
          const row = this.mainTabsEl;
          if (!row) return;
          const root = row.getBoundingClientRect();
          const tabs = this.mainTabButtons;
          const extendsPastRight = (b) => b.getBoundingClientRect().right > root.right + 2;
          let btn = tabs.find(
            (b) => extendsPastRight(b) && mainTabVisibleFracInRow(b, root) < MAIN_TAB_SKIP_SCROLL_IF_VISIBLE_FRAC,
          );
          if (!btn) {
            for (let i = tabs.length - 1; i >= 0; i -= 1) {
              if (extendsPastRight(tabs[i])) {
                btn = tabs[i];
                break;
              }
            }
          }
          if (btn) {
            if (
              this.mainTabsWrap &&
              typeof window.matchMedia !== 'undefined' &&
              window.matchMedia('(max-width: 768px)').matches &&
              btn === tabs[tabs.length - 1]
            ) {
              this.mainTabsWrap.classList.remove('bundle-builder__main-tabs-wrap--show-next');
            }
            btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          }
          window.requestAnimationFrame(() => this._syncMainTabsScrollHint());
          window.setTimeout(() => this._syncMainTabsScrollHint(), 400);
        };
        this._onMainTabsScrollPrevClick = (pointerEvent) => {
          pointerEvent.preventDefault();
          pointerEvent.stopPropagation();
          const row = this.mainTabsEl;
          if (!row) return;
          const root = row.getBoundingClientRect();
          const tabs = this.mainTabButtons;
          const extendsPastLeft = (b) => b.getBoundingClientRect().left < root.left - 2;
          let btn = null;
          for (let i = tabs.length - 1; i >= 0; i -= 1) {
            const b = tabs[i];
            if (extendsPastLeft(b) && mainTabVisibleFracInRow(b, root) < MAIN_TAB_SKIP_SCROLL_IF_VISIBLE_FRAC) {
              btn = b;
              break;
            }
          }
          if (!btn) {
            for (let i = 0; i < tabs.length; i += 1) {
              if (extendsPastLeft(tabs[i])) {
                btn = tabs[i];
                break;
              }
            }
          }
          if (btn) {
            if (
              this.mainTabsWrap &&
              typeof window.matchMedia !== 'undefined' &&
              window.matchMedia('(max-width: 768px)').matches &&
              btn === tabs[0]
            ) {
              this.mainTabsWrap.classList.remove('bundle-builder__main-tabs-wrap--show-prev');
            }
            btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          }
          window.requestAnimationFrame(() => this._syncMainTabsScrollHint());
          window.setTimeout(() => this._syncMainTabsScrollHint(), 400);
        };
        if (this.mainTabsEl && this.mainTabsWrap && this.mainTabsScrollNext && this.mainTabsScrollPrev) {
          this.mainTabsEl.addEventListener('scroll', this._syncMainTabsScrollHint);
          this.mainTabsEl.addEventListener('scrollend', this._syncMainTabsScrollHint);
          window.addEventListener('resize', this._syncMainTabsScrollHint);
          this.mainTabsScrollNext.addEventListener('click', this._onMainTabsScrollNextClick);
          this.mainTabsScrollPrev.addEventListener('click', this._onMainTabsScrollPrevClick);
        }
  
        this._onCartShippingUpdate = (event) => this._handleCartShippingUpdate(event);
        document.addEventListener('liquid-ajax-cart:init', this._onCartShippingUpdate);
        document.addEventListener('liquid-ajax-cart:request-end', this._onCartShippingUpdate);
        window.addEventListener('cart-open', this._onCartShippingUpdate);

        this._applySetFromUrl({ updateUrl: false });
        this._syncActiveSetUi();
        this._renderMiniSet();
        this._initSetSwiper();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this._syncMainTabsScrollHint?.();
          });
        });
      }
  
      disconnectedCallback() {
        if (this._onClick) this.removeEventListener('click', this._onClick);
        if (this._onQvPrefetch) {
          this.removeEventListener('pointerover', this._onQvPrefetch);
          this.removeEventListener('pointerdown', this._onQvPrefetch);
          this.removeEventListener('focusin', this._onQvPrefetch);
        }
        if (this._onQvResize) {
          window.removeEventListener('resize', this._onQvResize);
          window.clearTimeout(this._qvResizeTimer);
        }
        if (this.mainTabsEl && this._syncMainTabsScrollHint) {
          this.mainTabsEl.removeEventListener('scroll', this._syncMainTabsScrollHint);
          this.mainTabsEl.removeEventListener('scrollend', this._syncMainTabsScrollHint);
          window.removeEventListener('resize', this._syncMainTabsScrollHint);
        }
        if (this.mainTabsScrollNext && this._onMainTabsScrollNextClick) {
          this.mainTabsScrollNext.removeEventListener('click', this._onMainTabsScrollNextClick);
        }
        if (this.mainTabsScrollPrev && this._onMainTabsScrollPrevClick) {
          this.mainTabsScrollPrev.removeEventListener('click', this._onMainTabsScrollPrevClick);
        }
        if (this.mainTabsWrap) {
          this.mainTabsWrap.classList.remove(
            'bundle-builder__main-tabs-wrap--show-next',
            'bundle-builder__main-tabs-wrap--show-prev',
          );
        }
        if (this._miniSetMobileMq && this._onMiniSetMobileMq) {
          this._miniSetMobileMq.removeEventListener('change', this._onMiniSetMobileMq);
        }
        document.removeEventListener('keydown', this._onKeydownMiniSet);
        if (this._onCartShippingUpdate) {
          document.removeEventListener('liquid-ajax-cart:init', this._onCartShippingUpdate);
          document.removeEventListener('liquid-ajax-cart:request-end', this._onCartShippingUpdate);
          window.removeEventListener('cart-open', this._onCartShippingUpdate);
        }
        if (this._onPopstate) window.removeEventListener('popstate', this._onPopstate);
        window.clearTimeout(this._milestoneFillTimer);
        window.clearTimeout(this._milestoneReachTimer);
        this.closeQuickView();
        window.clearTimeout(this._qvTeardownTimer);
        this._closeMobileMiniSetUi();
        if (this._junipObserver) {
          this._junipObserver.disconnect();
          this._junipObserver = null;
        }
        if (this._junipFormatRaf) {
          cancelAnimationFrame(this._junipFormatRaf);
          this._junipFormatRaf = null;
        }
        this._destroySetSwiper();
        this._destroyQvSwiper();
      }
  
      _destroySetSwiper() {
        if (this._setSwiperMq && this._onSetSwiperMq) {
          this._setSwiperMq.removeEventListener('change', this._onSetSwiperMq);
          this._setSwiperMq = null;
          this._onSetSwiperMq = null;
        }
        if (this.setSwiper) {
          this.setSwiper.destroy(true, true);
          this.setSwiper = null;
        }
      }
  
      _initSetSwiper() {
        if (!this.setSwiperEl || typeof window.Swiper === 'undefined') return;
  
        this._destroySetSwiper();
        this._setSwiperMq =
          typeof window.matchMedia !== 'undefined' ? window.matchMedia('(max-width: 768px)') : null;
        if (!this._setSwiperMq) return;
  
        const mount = () => {
          if (!this.isConnected || !this.setSwiperEl) return;
          if (this._setSwiperMq.matches) {
            if (this.setSwiper) return;
            const activeSetIdx = this.setTabButtons.findIndex(
              (t) => t.getAttribute('aria-selected') === 'true',
            );
            this.setSwiper = new window.Swiper(this.setSwiperEl, {
              initialSlide: activeSetIdx >= 0 ? activeSetIdx : 0,
              slidesPerView: 'auto',
              spaceBetween: 8,
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              pagination: {
                el: this.setSwiperPaginationEl,
                clickable: true,
              },
              on: {
                slideChange: (swiper) => {
                  if (this._setSwiperFromSelect) return;
                  const setTab = this.setTabButtons[swiper.activeIndex];
                  if (setTab) this.selectSetTab(setTab);
                },
              },
            });
          } else if (this.setSwiper) {
            this.setSwiper.destroy(true, true);
            this.setSwiper = null;
          }
        };
  
        this._onSetSwiperMq = mount;
        mount();
        this._setSwiperMq.addEventListener('change', mount);
      }
  
      _formatJunipReviewCounts() {
        for (const el of this.querySelectorAll('.bundle-browse-card__junip .junip-product-summary-review-count')) {
          formatBundleJunipReviewCount(el);
        }
      }
  
      _initJunipReviewFormat() {
        this._formatJunipReviewCounts();
        try {
          if (window.junip?.storefrontStarsLoader) window.junip.storefrontStarsLoader();
          else if (window.junipLoader?.load) window.junipLoader.load();
        } catch {
          /* junip unavailable */
        }
        this._junipFormatRaf = null;
        this._junipObserver = new MutationObserver(() => {
          if (this._junipFormatRaf) return;
          this._junipFormatRaf = requestAnimationFrame(() => {
            this._junipFormatRaf = null;
            if (this.isConnected) this._formatJunipReviewCounts();
          });
        });
        this._junipObserver.observe(this, { childList: true, subtree: true, characterData: true });
      }
  
      formatMoney(cents) {
        const amount = cents / 100;
        const num = amount % 1 === 0 ? String(amount) : amount.toFixed(2);
        const usd = `$${num}`;
        if (this.currencyCode === 'USD') return usd;
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.currencyCode,
            currencyDisplay: 'narrowSymbol',
          })
            .format(amount)
            .replace(/^US\s*/i, '')
            .replace(/\.00$/, '');
        } catch {
          return usd;
        }
      }
  
      getLineQuantitySum() {
        return this.miniSetLines.reduce((acc, line) => acc + line.quantity, 0);
      }
  
      _loadTiers() {
        const el = this.querySelector('[data-bundle-tiers-config]');
        let tiers = [];
        if (el) {
          try {
            const parsed = JSON.parse(el.textContent);
            if (Array.isArray(parsed)) {
              tiers = parsed
                .map((tier) => ({
                  need: Number.parseInt(tier.need, 10),
                  pct: Number.parseInt(tier.pct, 10),
                  gift: Boolean(tier.gift),
                }))
                .filter((tier) => Number.isFinite(tier.need) && Number.isFinite(tier.pct))
                .sort((a, b) => a.need - b.need);
            }
          } catch {
            tiers = [];
          }
        }
        this.tiers = tiers;
        const giftTier = [...this.tiers].reverse().find((tier) => tier.gift);
        if (giftTier) this.giftTierMin = giftTier.need;
      }

      appliedDiscountPercent(quantitySum) {
        let pct = 0;
        for (const tier of this.tiers) {
          if (quantitySum >= tier.need) pct = tier.pct;
        }
        return pct;
      }
  
      _hasGiftProduct() {
        return Number.isFinite(this.giftVariantId);
      }
  
      _isGiftUnlocked(quantitySum) {
        return Number.isFinite(this.giftTierMin) && this.giftTierMin >= 1 && quantitySum >= this.giftTierMin;
      }
  
      _isGiftVariant(variantId) {
        return this._hasGiftProduct() && variantId === this.giftVariantId;
      }
  
      _showGiftFreeLine(quantitySum) {
        return this._isGiftUnlocked(quantitySum) && this._hasGiftProduct();
      }
  
      _giftCartTitle() {
        const vt = (this.giftVariantTitle || '').trim();
        if (vt && vt !== 'Default Title') return vt;
        return this.giftProductTitle || '';
      }
  
      _appendGiftLine(listEl, existingImg) {
        if (!listEl || !this._hasGiftProduct()) return;
        const li = document.createElement('li');
        li.className = 'bundle-set__line bundle-set__line--gift';
        li.setAttribute('data-gift-line', '');
        li.innerHTML = `
          <div class="bundle-set__line-main">
            <div class="bundle-set__line-head">
              <p class="bundle-set__line-title"></p>
              <span class="bundle-set__line-price"></span>
            </div>
            <p class="bundle-set__line-shade">FREE</p>
          </div>
        `;
        const img = existingImg || this._makeLineImg(this.giftImage, this.giftProductTitle);
        img.alt = this.giftProductTitle;
        li.prepend(img);
        li.querySelector('.bundle-set__line-title').textContent = this.giftProductTitle;
        li.querySelector('.bundle-set__line-price').textContent = this.formatMoney(0);
        listEl.appendChild(li);
      }
  
      buildGiftRewardHtml(maxPct) {
        const isFreeGift = this.dataset.freeGift === 'true';
        var str = `<strong class="bundle-set__unlock-reward">${maxPct}%&nbsp;OFF</strong>`
        if(isFreeGift){
          str = `a <strong class="bundle-set__unlock-reward"><span class="bundle-set__unlock-accent">FREE GIFT</span>&nbsp;+&nbsp;${maxPct}%&nbsp;OFF</strong>`
        }
        return str;
      }
  
      buildOfferHtml(quantitySum) {
        const tiers = this.tiers;
        if (!tiers.length) return '';
        const maxPct = tiers[tiers.length - 1].pct;

        const nextTier = tiers.find((tier) => quantitySum < tier.need) || null;
        if (!nextTier) {
          // Top tier reached — show the max discount unlocked, in the accent color.
          return `<strong>${maxPct}% OFF UNLOCKED</strong>`;
        }

        const remaining = nextTier.need - quantitySum;
        const appliedTier = [...tiers].reverse().find((tier) => quantitySum >= tier.need) || null;

        if (appliedTier) {
          // A discount is already applied: show the unlocked tier (accent) and
          // the next target (plain black, not accent).
          return `<strong>${appliedTier.pct}% OFF UNLOCKED</strong> &mdash; add ${remaining} more for <strong class="bundle-set__unlock-target">${nextTier.pct}% OFF</strong>`;
        }

        // Nothing unlocked yet.
        const itemWord = remaining === 1 ? 'item' : 'items';
        if (quantitySum > 0) {
          return `Add <strong>${remaining} more ${itemWord}</strong> to unlock <strong>${nextTier.pct}% OFF</strong>`;
        }
        return `Add <strong>${remaining} ${itemWord}</strong> to unlock <strong>${nextTier.pct}% OFF</strong> your set`;
      }

      buildUpsellHeading(quantitySum) {
        const tiers = this.tiers;
        if (!tiers.length) return '';
        const maxPct = tiers[tiers.length - 1].pct;
        const nextTier = tiers.find((tier) => quantitySum < tier.need) || null;
        if (!nextTier) return `${maxPct}% off applies to every sale item you add`;
        const remaining = nextTier.need - quantitySum;
        return `${remaining} AWAY FROM ${nextTier.pct}% OFF`;
      }
  
      syncMilestones(quantitySum, { instant = false } = {}) {
        const nextReached = this.milestoneEls.map((milestoneEl) => {
          const need = Number.parseInt(milestoneEl.getAttribute('data-bundle-set-milestone'), 10);
          return Number.isFinite(need) && quantitySum >= need;
        });

        const tiers = this.tiers;
        const segs = this.milestoneFillSegEls;
        const fills = [];
        if (segs.length && segs.length === tiers.length) {
          const lastIdx = tiers.length - 1;
          for (let i = 0; i <= lastIdx; i += 1) {
            const prevNeed = i === 0 ? 0 : tiers[i - 1].need;
            const need = tiers[i].need;
            const span = need - prevNeed;
            let fill = 0;
            if (quantitySum > prevNeed) fill = Math.min(1, (quantitySum - prevNeed) / span);
            if (i === lastIdx) {
              const dotScale = Number.parseFloat(segs[i].getAttribute('data-bundle-fill-dot-scale'));
              const scale = Number.isFinite(dotScale) ? dotScale : 1;
              fill = quantitySum > need ? 1 : fill * scale;
            }
            fills.push(fill);
          }
        }

        const prevFills = this._milestoneFills;
        const prevReached = this._milestoneReached;
        const hasPrev =
          Array.isArray(prevFills)
          && prevFills.length === fills.length
          && Array.isArray(prevReached)
          && prevReached.length === nextReached.length;

        const setReached = (state) => {
          this.milestoneEls.forEach((el, i) => {
            el.classList.toggle('bundle-set__milestone--reached', Boolean(state[i]));
          });
        };

        const applyFills = (nextFills, animate) => {
          for (let i = 0; i < nextFills.length && i < segs.length; i += 1) {
            const seg = segs[i];
            if (!animate) {
              seg.style.transition = 'none';
              seg.style.transform = `scaleX(${nextFills[i]})`;
              void seg.offsetWidth;
              seg.style.transition = '';
            } else {
              seg.style.transform = `scaleX(${nextFills[i]})`;
            }
          }
        };

        window.clearTimeout(this._milestoneFillTimer);
        window.clearTimeout(this._milestoneReachTimer);

        if (!fills.length) {
          setReached(nextReached);
        } else if (instant) {
          applyFills(fills, false);
          setReached(nextReached);
        } else {
          // A dot belongs to the end of its segment: it fills only once the bar
          // has travelled to it, and empties before the bar retreats.
          const prevState = hasPrev ? prevReached : nextReached.map(() => false);
          const emptyingDot = prevState.some((was, i) => was && !nextReached[i]);
          applyFills(hasPrev ? prevFills : fills.map(() => 0), false);
          setReached(prevState.map((was, i) => was && nextReached[i]));
          const startFill = () => {
            applyFills(fills, true);
            this._milestoneReachTimer = window.setTimeout(
              () => setReached(nextReached),
              MILESTONE_FILL_MS,
            );
          };
          if (emptyingDot) {
            this._milestoneFillTimer = window.setTimeout(startFill, MILESTONE_DOT_MS);
          } else {
            requestAnimationFrame(() => requestAnimationFrame(startFill));
          }
        }

        this._milestoneQty = quantitySum;
        this._milestoneFills = fills;
        this._milestoneReached = nextReached;
      }

      syncMilestoneProgressFill(quantitySum) {
        this.syncMilestones(quantitySum);
      }
  
      _handleMiniSetUi(pointerEvent) {
        const mobileDismiss = pointerEvent.target.closest('[data-bundle-set-mobile-dismiss]');
        if (mobileDismiss && this.contains(mobileDismiss)) {
          this._dismissMobileMiniSetBackdrop();
          pointerEvent.preventDefault();
          return;
        }
        const mobileToggle = pointerEvent.target.closest('[data-bundle-set-mobile-close]');
        if (mobileToggle && this.contains(mobileToggle)) {
          this._toggleMobileMiniSetExpanded();
          pointerEvent.preventDefault();
          return;
        }
        const mobileHeaderExpand = pointerEvent.target.closest('.bundle-set__header');
        if (
          mobileHeaderExpand &&
          this.contains(mobileHeaderExpand) &&
          this._miniSetMobileMq?.matches &&
          this.classList.contains('bundle-builder--set-peek') &&
          !this.classList.contains('bundle-builder--set-open')
        ) {
          this._openMobileMiniSetUi();
          pointerEvent.preventDefault();
          return;
        }
        const checkoutGo = pointerEvent.target.closest('[data-bundle-set-checkout-btn]');
        if (checkoutGo && this.contains(checkoutGo)) {
          pointerEvent.preventDefault();
          void this._addMiniSetToCart();
          return;
        }
        const qtyBtn = pointerEvent.target.closest('[data-bundle-set-qty]');
        if (qtyBtn && this.contains(qtyBtn)) {
          if (this._checkoutLoading) {
            pointerEvent.preventDefault();
            return;
          }
          const lineId = qtyBtn.getAttribute('data-bundle-set-line');
          const delta = Number.parseInt(qtyBtn.getAttribute('data-bundle-set-qty'), 10);
          const line = this.miniSetLines.find((l) => String(l.variantId) === lineId);
          if (line) {
            const nextQty = line.quantity + delta;
            if (nextQty < 1) {
              this.miniSetLines = this.miniSetLines.filter((l) => l.variantId !== line.variantId);
            } else {
              line.quantity = nextQty;
            }
          }
          this._renderMiniSet();
          if (delta > 0) this._scrollBundleLinesToLast();
          pointerEvent.preventDefault();
        }
      }
  
      _initQtyIcons() {
        const withIconClass = (markup) => {
          if (!markup) return '';
          return markup.replace('<svg', '<svg class="bundle-set__line-qty-icon" aria-hidden="true" focusable="false"');
        };
        this.deleteIconSvg = withIconClass(
          this.querySelector('[data-bundle-qty-delete-icon]')?.innerHTML.trim() || '',
        );
        this.minusIconSvg = withIconClass(
          this.querySelector('[data-bundle-qty-minus-icon]')?.innerHTML.trim() || '',
        );
        this.plusIconSvg = withIconClass(
          this.querySelector('[data-bundle-qty-plus-icon]')?.innerHTML.trim() || '',
        );
      }
  
      _lineQtyDecreaseButton(line) {
        const lineId = line.variantId;
        if (line.quantity === 1) {
          return `<button type="button" class="bundle-set__line-qty-dec bundle-set__line-qty-dec--delete" data-bundle-set-qty="-1" data-bundle-set-line="${lineId}" aria-label="Remove from set">${this.deleteIconSvg}</button>`;
        }
        return `<button type="button" class="bundle-set__line-qty-dec" data-bundle-set-qty="-1" data-bundle-set-line="${lineId}" aria-label="Decrease quantity">${this.minusIconSvg}</button>`;
      }
  
      _lineQtyIncreaseButton(line) {
        return `<button type="button" class="bundle-set__line-qty-inc" data-bundle-set-qty="1" data-bundle-set-line="${line.variantId}" aria-label="Increase quantity">${this.plusIconSvg}</button>`;
      }
  
      _lineDisplayTitle(productTitle, variantTitle) {
        const vt = (variantTitle || '').trim();
        if (!vt || vt === 'Default Title') return productTitle;
        return `${productTitle} — ${vt}`;
      }
  
      _browseCardImageSrc(card, variantImgAttr) {
        const img = card.querySelector('.bundle-browse-card__img');
        return img?.currentSrc || img?.src || variantImgAttr || '';
      }

      _liveImgForLine(productId) {
        const qvPanel = this.quickviewMount?.querySelector('.bundle-qv__panel');
        const qvProductId = qvPanel?.getAttribute('data-product-id');
        if (productId && qvProductId && String(productId) === String(qvProductId)) {
          const qvImg =
            this.quickviewMount.querySelector('.swiper-slide-active .bundle-qv__img') ||
            this.quickviewMount.querySelector('.bundle-qv__img');
          if (qvImg?.currentSrc || qvImg?.src) return qvImg;
        }
        if (!productId) return null;
        const cardImg = this.querySelector(
          `[data-bundle-browse-card][data-product-id="${productId}"] .bundle-browse-card__img`,
        );
        if (cardImg?.currentSrc || cardImg?.src) return cardImg;
        return null;
      }

      _makeLineImg(src, alt, productId) {
        const live = this._liveImgForLine(productId);
        const url = live?.currentSrc || live?.src || src || '';
        const img = live ? live.cloneNode(true) : document.createElement('img');
        img.className = 'bundle-set__line-img';
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.removeAttribute('loading');
        img.removeAttribute('fetchpriority');
        img.width = 88;
        img.height = 88;
        img.alt = alt || '';
        if (url) img.src = url;
        return img;
      }
  
      _pushMiniSetLine({ variantId, priceCents, productId, productTitle, variantTitle, image }) {
        if (!Number.isFinite(variantId) || !Number.isFinite(priceCents)) return false;
        const title = variantTitle || '';
        const displayTitle = this._lineDisplayTitle(productTitle || '', title);
        const existing = this.miniSetLines.find((line) => line.variantId === variantId);
        if (existing) {
          existing.quantity += 1;
        } else {
          this.miniSetLines.push({
            variantId,
            productId,
            productTitle: productTitle || '',
            title: displayTitle,
            variantTitle: title,
            price: priceCents,
            quantity: 1,
            image: image || '',
          });
        }
        return true;
      }

      _addBrowseCardToMiniSet(card) {
        if (!card || card.classList.contains('bundle-browse-card--sold-out')) return false;
        // Single-variant cards add straight from their CTA; multi-shade cards
        // have no in-card picker, so fall back to the default shade held in the
        // quick-view template.
        const addBtn = card.querySelector('[data-bundle-add-direct]');
        const tplContent = addBtn ? null : card.querySelector('[data-bundle-modal]')?.content;
        const selected =
          tplContent?.querySelector('[data-bundle-qv-swatch].is-selected') ||
          tplContent?.querySelector('[data-bundle-qv-swatch]');
        const source = addBtn || selected;
        if (!source) return false;
        const variantId = Number.parseInt(source.getAttribute('data-variant-id'), 10);
        const priceCents = Number.parseInt(source.getAttribute('data-variant-price'), 10);
        const productTitle = card.getAttribute('data-product-title') || '';
        const variantTitle = selected
          ? selected.getAttribute('data-variant-title') || ''
          : '';
        const variantImg = selected ? selected.getAttribute('data-variant-img') || '' : '';
        const productId = Number.parseInt(card.getAttribute('data-product-id'), 10);
        const imageSrc = this._browseCardImageSrc(card, variantImg);
        return this._pushMiniSetLine({
          variantId,
          priceCents,
          productId,
          productTitle,
          variantTitle,
          image: imageSrc,
        });
      }
  
      _addAllSetFromPanel(panel) {
        let added = false;
        for (const card of panel.querySelectorAll('[data-bundle-browse-card]')) {
          if (this._addBrowseCardToMiniSet(card)) added = true;
        }
        if (!added) return;
        if (this._miniSetMobileMq?.matches) {
          this._resetMobileMiniSetPeek();
          this._closeMobileMiniSetUi();
        }
        this._renderMiniSet();
        this._scrollBundleLinesToLast();
      }
  
      _resetMobileMiniSetPeek() {
        this._mobilePeekDismissed = false;
      }
  
      _handleQuickView(pointerEvent) {
        const opener = pointerEvent.target.closest('[data-bundle-quickview-open]');
        if (opener && this.contains(opener)) {
          const card = opener.closest('[data-bundle-browse-card]');
          if (card) {
            this.openQuickView(card);
            pointerEvent.preventDefault();
            return true;
          }
        }
        if (!this.quickview) return false;
        const closer = pointerEvent.target.closest(
          '[data-bundle-quickview-close], [data-bundle-quickview-dismiss]',
        );
        if (closer && this.quickview.contains(closer)) {
          this.closeQuickView();
          pointerEvent.preventDefault();
          return true;
        }
        if (!this.quickview.contains(pointerEvent.target)) return false;
        if (pointerEvent.target.closest('[data-bundle-qv-prev]')) {
          this._qvGo(-1);
          pointerEvent.preventDefault();
          return true;
        }
        if (pointerEvent.target.closest('[data-bundle-qv-next]')) {
          this._qvGo(1);
          pointerEvent.preventDefault();
          return true;
        }
        const dot = pointerEvent.target.closest('[data-bundle-qv-dot]');
        if (dot) {
          this._qvGoTo(Number.parseInt(dot.getAttribute('data-bundle-qv-dot'), 10) || 0);
          pointerEvent.preventDefault();
          return true;
        }
        const qvMore = pointerEvent.target.closest('[data-bundle-qv-more]');
        if (qvMore) {
          const list = this.quickview.querySelector('.bundle-qv__swatches');
          if (list) {
            list.dataset.qvExpanded = 'true';
            this._layoutQvSwatches();
          }
          pointerEvent.preventDefault();
          return true;
        }
        const swatch = pointerEvent.target.closest('[data-bundle-qv-swatch]');
        if (swatch) {
          this._qvSelectSwatch(swatch);
          pointerEvent.preventDefault();
          return true;
        }
        const add = pointerEvent.target.closest('[data-bundle-qv-add]');
        if (add) {
          if (!this._checkoutLoading) this._qvAddToSet();
          pointerEvent.preventDefault();
          return true;
        }
        return false;
      }

      _prefetchQuickView(card) {
        if (!card || !this._qvPrefetched || this._qvPrefetched.has(card)) return;
        this._qvPrefetched.add(card);
        const tpl = card.querySelector('[data-bundle-modal]');
        if (!tpl || !tpl.content) return;
        const panel = tpl.content.querySelector('.bundle-qv__panel');
        const media = panel ? panel.getAttribute('data-qv-media') || '' : '';
        const urls = this._qvSlidesFrom(media);
        for (const url of urls) {
          const img = new Image();
          img.decoding = 'async';
          img.src = url;
        }
      }

      _qvWarmAllSwatches() {
        // Once the modal is open, warm every shade's gallery so switching
        // swatches is instant. First images (shown immediately on switch) are
        // fetched before the secondary slides. Deferred to idle so it doesn't
        // compete with the currently visible image.
        const run = () => {
          const mount = this.quickviewMount;
          if (!mount) return;
          const swatches = [...mount.querySelectorAll('[data-bundle-qv-swatch]')];
          if (!swatches.length) return;
          const firsts = [];
          const rest = [];
          for (const swatch of swatches) {
            const urls = this._qvSlidesFrom(swatch.getAttribute('data-variant-media'));
            urls.forEach((url, i) => (i === 0 ? firsts : rest).push(url));
          }
          const seen = new Set();
          for (const url of firsts.concat(rest)) {
            if (!url || seen.has(url)) continue;
            seen.add(url);
            const img = new Image();
            img.decoding = 'async';
            img.src = url;
          }
        };
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(run, { timeout: 1000 });
        } else {
          window.setTimeout(run, 200);
        }
      }

      // Modal shade collapse: one full row + a single shade on the second row,
      // then a "+N" pill — mobile keeps it to a single row that ends with the
      // pill. Clicking the pill (data-bundle-qv-more) shows the rest.
      _layoutQvSwatches() {
        const mount = this.quickviewMount;
        if (!mount) return;
        const list = mount.querySelector('.bundle-qv__swatches');
        if (!list) return;
        const moreLi = list.querySelector('[data-bundle-qv-more-li]');
        const moreBtn = list.querySelector('[data-bundle-qv-more]');
        const items = [...list.querySelectorAll('.bundle-qv__swatch-li')].filter((li) => li !== moreLi);
        if (!items.length || !list.getClientRects().length) return;
        for (const li of items) li.style.display = '';
        if (moreLi) moreLi.setAttribute('hidden', '');
        if (list.dataset.qvExpanded === 'true') return;
        const total = items.length;

        // Mobile: the row can't wrap, so whatever doesn't fit beside the pill
        // is counted into "+N".
        if (window.matchMedia('(max-width: 767px)').matches) {
          if (list.scrollWidth <= list.clientWidth + 1) return;
          if (!moreLi || !moreBtn) return;
          moreLi.removeAttribute('hidden');
          moreBtn.textContent = `${total - 1}+`; // widest label reserves its space
          const gap = Number.parseFloat(getComputedStyle(list).columnGap) || 0;
          const slot = items[0].offsetWidth + gap;
          const room = list.clientWidth - moreLi.offsetWidth;
          const visible = Math.max(1, Math.min(total - 1, Math.floor(room / slot)));
          for (let i = visible; i < total; i += 1) items[i].style.display = 'none';
          moreBtn.textContent = `${total - visible}+`;
          return;
        }

        const firstTop = items[0].offsetTop;
        let perRow = 0;
        for (const li of items) {
          if (Math.abs(li.offsetTop - firstTop) < 2) perRow += 1;
          else break;
        }
        if (perRow < 1) return;
        const maxVisible = perRow + 1; // full first row + one shade on the second row
        if (total <= maxVisible) return;
        for (let i = maxVisible; i < total; i += 1) items[i].style.display = 'none';
        if (moreBtn) moreBtn.textContent = `${total - maxVisible}+`;
        if (moreLi) moreLi.removeAttribute('hidden');
      }

      openQuickView(card, { fromUpsell = false } = {}) {
        if (!card || !this.quickview || !this.quickviewMount) return;
        const tpl = card.querySelector('[data-bundle-modal]');
        if (!tpl || !('content' in tpl)) return;
        this._qvFromUpsell = fromUpsell;
        window.clearTimeout(this._qvTeardownTimer);
        this._destroyQvSwiper();
        this._qvSourceCard = card;
        this.quickviewMount.innerHTML = '';
        this.quickviewMount.appendChild(tpl.content.cloneNode(true));
        const mount = this.quickviewMount;
        const selected =
          mount.querySelector('[data-bundle-qv-swatch].is-selected') ||
          mount.querySelector('[data-bundle-qv-swatch]');
        const panel = mount.querySelector('.bundle-qv__panel');
        const media = selected
          ? selected.getAttribute('data-variant-media')
          : panel
            ? panel.getAttribute('data-qv-media')
            : '';
        // Show first so the container has dimensions, then init the Swiper.
        this.quickview.removeAttribute('hidden');
        this.classList.add('bundle-builder--qv-open');
        document.documentElement.style.overflow = 'hidden';
        this._qvLoadGallery(media);
        this._qvWarmAllSwatches();
        this._layoutQvSwatches();
        const closeBtn = this.quickview.querySelector('[data-bundle-quickview-close]');
        if (closeBtn) requestAnimationFrame(() => closeBtn.focus());
      }

      closeQuickView() {
        if (!this.quickview) return;
        this._qvLoadSeq = (this._qvLoadSeq || 0) + 1; // invalidate any in-flight image load
        this.quickview.setAttribute('hidden', '');
        this.classList.remove('bundle-builder--qv-open');
        this._qvFromUpsell = false;
        if (this.classList.contains('bundle-builder--set-open')) {
          document.documentElement.style.overflow = 'hidden';
        } else {
          document.documentElement.style.overflow = '';
        }
        this._qvSourceCard = null;
        window.clearTimeout(this._qvTeardownTimer);
        this._qvTeardownTimer = window.setTimeout(() => {
          this._destroyQvSwiper();
          this._qvTrack = null;
          this._qvSlides = [];
          this._qvDotsWrap = null;
          if (this.quickviewMount) this.quickviewMount.innerHTML = '';
        }, QV_EXIT_MS);
      }

      _qvSlidesFrom(mediaStr) {
        return (mediaStr || '')
          .split('||')
          .map((url) => url.trim())
          .filter(Boolean)
          .slice(0, 3);
      }

      _qvResolveUrls(mediaStr) {
        let urls = this._qvSlidesFrom(mediaStr);
        if (!urls.length) {
          const panel = this.quickviewMount?.querySelector('.bundle-qv__panel');
          const fallback = panel ? panel.getAttribute('data-product-image') || '' : '';
          if (fallback) urls = [fallback];
        }
        return urls;
      }

      // Decode the target's first image OFF-DOM first, keeping whatever is
      // currently shown (old image on switch, skeleton on open) visible until
      // it's ready — then swap. A spinner fades in only if the load takes a
      // moment (>250ms via CSS), so cached images stay instant. Rapid switches
      // are guarded by a sequence token so only the latest wins. This adds no
      // network cost (the preload shares the browser cache with the real img).
      _qvLoadGallery(mediaStr) {
        const mount = this.quickviewMount;
        if (!mount) return;
        const media = mount.querySelector('.bundle-qv__media');
        const urls = this._qvResolveUrls(mediaStr);
        const seq = (this._qvLoadSeq = (this._qvLoadSeq || 0) + 1);
        if (!urls.length) {
          if (media) media.classList.remove('bundle-qv__media--loading');
          this._qvBuildGallery([]);
          return;
        }
        if (media) media.classList.add('bundle-qv__media--loading');
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          if (seq !== this._qvLoadSeq) return; // superseded by a newer open/switch
          if (media) media.classList.remove('bundle-qv__media--loading');
          this._qvBuildGallery(urls);
        };
        const img = new Image();
        img.decoding = 'async';
        img.onload = finish;
        img.onerror = finish;
        img.src = urls[0];
        if (img.decode) img.decode().then(finish, finish);
        if (img.complete) finish(); // already cached → swap immediately
        window.setTimeout(finish, 1500); // safety net for very slow networks
      }

      _qvBuildGallery(urls) {
        const mount = this.quickviewMount;
        if (!mount) return;
        const track = mount.querySelector('[data-bundle-qv-track]');
        if (!track) return;
        track.innerHTML =
          '<div class="swiper-wrapper">' +
          urls
            .map(
              (url, i) =>
                `<div class="swiper-slide bundle-qv__slide"><img class="bundle-qv__img" src="${url}" alt="" draggable="false" ${i === 0 ? 'fetchpriority="high"' : 'loading="lazy"'} /></div>`,
            )
            .join('') +
          '</div>';
        this._initQvCarousel();
      }

      _destroyQvSwiper() {
        if (this._qvSwiper) {
          this._qvSwiper.destroy(true, true);
          this._qvSwiper = null;
        }
      }

      _initQvCarousel() {
        const mount = this.quickviewMount;
        this._destroyQvSwiper();
        const track = mount.querySelector('[data-bundle-qv-track]');
        this._qvTrack = track || null;
        this._qvSlides = track ? [...track.querySelectorAll('.swiper-slide')] : [];
        this._qvIndex = 0;
        const multi = this._qvSlides.length > 1;
        this._qvPrevBtn = mount.querySelector('[data-bundle-qv-prev]');
        this._qvNextBtn = mount.querySelector('[data-bundle-qv-next]');
        this._qvDotsWrap = mount.querySelector('[data-bundle-qv-dots]');
        if (this._qvDotsWrap) {
          this._qvDotsWrap.toggleAttribute('hidden', !multi);
          this._qvDotsWrap.innerHTML = multi
            ? this._qvSlides
                .map(
                  (_, i) =>
                    `<button type="button" class="bundle-qv__dot" data-bundle-qv-dot="${i}" aria-label="Go to image ${i + 1}"></button>`,
                )
                .join('')
            : '';
        }
        this._qvSyncDots();
        this._qvSyncNav();
        // Smooth, momentum-based swiping via the theme's Swiper (loaded in
        // layout/theme.liquid). Custom arrows/dots stay wired to it below.
        if (track && multi && typeof window.Swiper !== 'undefined') {
          this._qvSwiper = new window.Swiper(track, {
            slidesPerView: 1,
            grabCursor: true,
            speed: 350,
            resistanceRatio: 0.6,
            on: {
              slideChange: (sw) => {
                this._qvIndex = sw.activeIndex;
                this._qvSyncDots();
                this._qvSyncNav();
              },
            },
          });
        }
      }

      _qvSyncDots() {
        if (!this._qvDotsWrap) return;
        const dots = [...this._qvDotsWrap.querySelectorAll('[data-bundle-qv-dot]')];
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this._qvIndex));
      }

      _qvSyncNav() {
        const count = this._qvSlides ? this._qvSlides.length : 0;
        const i = this._qvIndex || 0;
        const multi = count > 1;
        // Hide the prev arrow on the first image and the next arrow on the last.
        if (this._qvPrevBtn) this._qvPrevBtn.toggleAttribute('hidden', !multi || i <= 0);
        if (this._qvNextBtn) this._qvNextBtn.toggleAttribute('hidden', !multi || i >= count - 1);
      }

      _qvGo(delta) {
        if (!this._qvSwiper) return;
        if (delta < 0) this._qvSwiper.slidePrev();
        else this._qvSwiper.slideNext();
      }

      _qvGoTo(index) {
        if (this._qvSwiper) this._qvSwiper.slideTo(index);
      }

      _qvSelectSwatch(swatch) {
        if (!swatch || !this.quickviewMount) return;
        const mount = this.quickviewMount;
        for (const btn of mount.querySelectorAll('[data-bundle-qv-swatch]')) {
          btn.classList.toggle('is-selected', btn === swatch);
        }
        // Swap the gallery to the newly selected variant's media (like the PDP)
        // — decode-first so the current image stays until the new one is ready.
        this._qvLoadGallery(swatch.getAttribute('data-variant-media'));
        const name = swatch.getAttribute('data-variant-title') || '';
        const desc = swatch.getAttribute('data-variant-desc') || '';
        const priceCents = Number.parseInt(swatch.getAttribute('data-variant-price'), 10);
        const variantId = swatch.getAttribute('data-variant-id') || '';
        const nameEl = mount.querySelector('[data-bundle-qv-name]');
        const descEl = mount.querySelector('[data-bundle-qv-desc]');
        if (nameEl) nameEl.textContent = name;
        if (descEl) {
          if (desc) {
            descEl.textContent = desc;
            descEl.removeAttribute('hidden');
          } else {
            descEl.textContent = '';
            descEl.setAttribute('hidden', '');
          }
        }
        const addBtn = mount.querySelector('[data-bundle-qv-add]');
        if (addBtn) {
          if (variantId) addBtn.setAttribute('data-variant-id', variantId);
          if (Number.isFinite(priceCents)) addBtn.setAttribute('data-variant-price', String(priceCents));
        }
        const priceEl = mount.querySelector('[data-bundle-qv-price]');
        if (priceEl && Number.isFinite(priceCents)) priceEl.textContent = this.formatMoney(priceCents);
      }

      _qvAddToSet() {
        const mount = this.quickviewMount;
        if (!mount) return;
        const panel = mount.querySelector('.bundle-qv__panel');
        const addBtn = mount.querySelector('[data-bundle-qv-add]');
        if (!panel || !addBtn) return;
        const selected = mount.querySelector('[data-bundle-qv-swatch].is-selected');
        const source = selected || addBtn;
        const variantId = Number.parseInt(source.getAttribute('data-variant-id'), 10);
        const priceCents = Number.parseInt(source.getAttribute('data-variant-price'), 10);
        const productId = Number.parseInt(panel.getAttribute('data-product-id'), 10);
        const productTitle = panel.getAttribute('data-product-title') || '';
        const variantTitle = selected ? selected.getAttribute('data-variant-title') || '' : '';
        const variantImg = selected ? selected.getAttribute('data-variant-img') || '' : '';
        const productImg = panel.getAttribute('data-product-image') || '';
        const qvImg =
          mount.querySelector('.swiper-slide-active .bundle-qv__img') ||
          mount.querySelector('.bundle-qv__img');
        const added = this._pushMiniSetLine({
          variantId,
          priceCents,
          productId,
          productTitle,
          variantTitle,
          image: qvImg?.currentSrc || qvImg?.src || variantImg || productImg,
        });
        if (!added) return;
        if (this._miniSetMobileMq?.matches && !this._qvFromUpsell) {
          this._resetMobileMiniSetPeek();
          this._closeMobileMiniSetUi();
        }
        this._qvFromUpsell = false;
        this._renderMiniSet();
        this._scrollBundleLinesToLast();
        this.closeQuickView();
      }

      _handleBrowseCards(pointerEvent) {
        // "View" shortcuts inside the empty Your Set panel jump straight to a
        // curated set: reveal the Shop-Bobbi's-Set view, then filter to it.
        const setView = pointerEvent.target.closest('[data-bundle-set-view]');
        if (setView && this.contains(setView)) {
          if (this._miniSetMobileMq?.matches) {
            this._hideMobileMiniSetPeek();
          }
          this.selectView('sets');
          this.enterSetFilter(setView);
          pointerEvent.preventDefault();
          return true;
        }

        const setBack = pointerEvent.target.closest('[data-bundle-set-back]');
        if (setBack && this.contains(setBack)) {
          // "Shop All" un-pins the curated set but stays in the current view
          // (Shop Bobbi's Set keeps its cards + the Build-Your-Own grid below);
          // it only restores the default heading, tabs and full product grid.
          this._resetSetFilterUi();
          pointerEvent.preventDefault();
          return true;
        }

        const shopSet = pointerEvent.target.closest('[data-bundle-set-shop]');
        if (shopSet && this.contains(shopSet)) {
          this.enterSetFilter(shopSet);
          pointerEvent.preventDefault();
          return true;
        }

        // The whole curated-set card is clickable, not just its CTA — any click
        // inside it filters to that set using the CTA's data attributes.
        const setCard = pointerEvent.target.closest('[data-bundle-set-card]');
        if (setCard && this.contains(setCard)) {
          const cta = setCard.querySelector('[data-bundle-set-shop]');
          if (cta) {
            this.enterSetFilter(cta);
            pointerEvent.preventDefault();
            return true;
          }
        }

        const setAddAll = pointerEvent.target.closest('[data-bundle-set-add-all]');
        if (setAddAll && this.contains(setAddAll)) {
          // Lines added while a checkout is in flight would be wiped when the
          // success path clears miniSetLines — swallow set mutations until done.
          if (this._checkoutLoading) {
            pointerEvent.preventDefault();
            return true;
          }
          const panel = setAddAll.closest('[data-bundle-products-panel]');
          const panelId = panel?.getAttribute('data-bundle-products-panel') || '';
          if (!panel || panel.hasAttribute('hidden') || !panelId.startsWith('set-')) return false;
          this._addAllSetFromPanel(panel);
          pointerEvent.preventDefault();
          return true;
        }

        const setUpsellAdd = pointerEvent.target.closest('[data-bundle-set-upsell-add]');
        if (setUpsellAdd && this.contains(setUpsellAdd)) {
          this._handleSetUpsellAdd(setUpsellAdd);
          pointerEvent.preventDefault();
          return true;
        }
  
        const addBtn = pointerEvent.target.closest('[data-bundle-add-direct]');
        if (addBtn && this.contains(addBtn)) {
          if (this._checkoutLoading) {
            pointerEvent.preventDefault();
            return true;
          }
          const card = addBtn.closest('[data-bundle-browse-card]');
          const panel = card?.closest('[data-bundle-products-panel]');
          if (!card || !panel || panel.hasAttribute('hidden')) return false;
          if (!this._addBrowseCardToMiniSet(card)) return true;
          if (this._miniSetMobileMq?.matches) {
            this._resetMobileMiniSetPeek();
            this._closeMobileMiniSetUi();
          }
          this._renderMiniSet();
          this._scrollBundleLinesToLast();
          pointerEvent.preventDefault();
          return true;
        }
  
        return false;
      }

      _scrollBundleLinesToLast() {
        const list = this.linesListEl;
        if (!list || list.hasAttribute('hidden')) return;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            try {
              list.scrollTo({ top: list.scrollHeight, behavior: 'smooth' });
            } catch {
              list.scrollTop = list.scrollHeight;
            }
          });
        });
      }
  
      _renderMiniSet({ instantMilestones = false } = {}) {
        const qtySum = this.getLineQuantitySum();
        if (this.itemCountEl) {
          this.itemCountEl.textContent = qtySum === 1 ? '1 item' : `${qtySum} items`;
        }
        if (this.offerTextEls && this.offerTextEls.length) {
          const offerHtml = this.buildOfferHtml(qtySum);
          for (const el of this.offerTextEls) el.innerHTML = offerHtml;
        }
        this.syncMilestones(qtySum, { instant: instantMilestones });
  
        let subtotalCents = 0;
        for (const line of this.miniSetLines) {
          if (this._showGiftFreeLine(qtySum) && this._isGiftVariant(line.variantId)) continue;
          subtotalCents += line.price * line.quantity;
        }
        const pct = this.appliedDiscountPercent(qtySum);
        const discountCents = Math.round((subtotalCents * pct) / 100);
        const finalCents = subtotalCents - discountCents;
        this._bundleFinalCents = finalCents;
  
        if (this.linesListEl) {
          const prevImgs = new Map();
          for (const row of this.linesListEl.querySelectorAll('.bundle-set__line')) {
            const prevImg = row.querySelector('.bundle-set__line-img');
            if (!prevImg) continue;
            const key = row.hasAttribute('data-gift-line')
              ? '__gift__'
              : row.getAttribute('data-variant-id');
            if (key) prevImgs.set(key, prevImg);
          }
          this.linesListEl.innerHTML = '';
          if (this._showGiftFreeLine(qtySum)) {
            this._appendGiftLine(this.linesListEl, prevImgs.get('__gift__'));
          }
          for (const line of this.miniSetLines) {
            if (this._showGiftFreeLine(qtySum) && this._isGiftVariant(line.variantId)) continue;
            const li = document.createElement('li');
            li.className = 'bundle-set__line';
            li.setAttribute('data-variant-id', String(line.variantId));
            const lineTotal = line.price * line.quantity;
            li.innerHTML = `
              <div class="bundle-set__line-main">
                <div class="bundle-set__line-head">
                  <p class="bundle-set__line-title"></p>
                  <span class="bundle-set__line-price"></span>
                </div>
                <p class="bundle-set__line-shade"></p>
                <div class="bundle-set__line-meta">
                  <span class="bundle-set__line-qty">
                    ${this._lineQtyDecreaseButton(line)}
                    <span class="bundle-set__line-qty-value">${line.quantity}</span>
                    ${this._lineQtyIncreaseButton(line)}
                  </span>
                </div>
              </div>
            `;
            const productTitle =
              line.productTitle ||
              (line.title.includes(' — ') ? line.title.split(' — ')[0] : line.title);
            const variantTitle = (line.variantTitle || '').trim();
            const showShade = variantTitle && variantTitle !== 'Default Title';
            const img =
              prevImgs.get(String(line.variantId)) ||
              this._makeLineImg(line.image, productTitle, line.productId);
            img.alt = productTitle;
            li.prepend(img);
            li.querySelector('.bundle-set__line-title').textContent = productTitle;
            const shadeEl = li.querySelector('.bundle-set__line-shade');
            if (showShade) {
              shadeEl.textContent = variantTitle;
              shadeEl.removeAttribute('hidden');
            } else {
              shadeEl.setAttribute('hidden', '');
            }
            li.querySelector('.bundle-set__line-price').textContent = this.formatMoney(lineTotal);
            this.linesListEl.appendChild(li);
          }
        }
  
        const hasItems = this.getLineQuantitySum() > 0;
        if (this.emptyEl) this.emptyEl.toggleAttribute('hidden', hasItems);
        if (this.emptyBannerEl) this.emptyBannerEl.toggleAttribute('hidden', this._isGiftUnlocked(qtySum));
        if (this.linesListEl) this.linesListEl.toggleAttribute('hidden', !hasItems);
        this._syncSetUpsells(qtySum, hasItems);

        if (this.strikeEl) {
          if (pct > 0 && subtotalCents > 0) {
            this.strikeEl.textContent = this.formatMoney(subtotalCents);
            this.strikeEl.removeAttribute('hidden');
          } else {
            this.strikeEl.setAttribute('hidden', '');
          }
        }
        if (this.discountPillEl) {
          if (pct > 0) {
            const giftUnlocked = this._showGiftFreeLine(qtySum);
            this.discountPillEl.textContent = giftUnlocked
              ? `${pct}% OFF + FREE GIFT`
              : `${pct}% OFF`;
            this.discountPillEl.removeAttribute('hidden');
          } else {
            this.discountPillEl.setAttribute('hidden', '');
          }
        }
        if (this.finalEl) {
          this.finalEl.textContent = this.formatMoney(finalCents);
        }
        this._syncShippingMessage();
        this._syncCheckoutButton(qtySum);
        this._syncMobileMiniSetChrome();
      }

      _firstTier() {
        return this.tiers?.[0] || null;
      }

      _meetsCheckoutMin(qtySum) {
        const first = this._firstTier();
        if (!first?.need) return qtySum > 0;
        return qtySum >= first.need;
      }

      _syncCheckoutButton(qtySum) {
        if (!this.checkoutBtn || this._checkoutLoading) return;
        const first = this._firstTier();
        const meetsMin = this._meetsCheckoutMin(qtySum);
        const canCheckout = meetsMin && Boolean(this.cartDiscountKey);
        this.checkoutBtn.disabled = !canCheckout;
        if (!meetsMin && first) {
          const remaining = Math.max(0, first.need - qtySum);
          const itemWord = remaining === 1 ? 'item' : 'items';
          this.checkoutBtn.textContent = qtySum > 0
            ? `Add ${remaining} more ${itemWord} to unlock ${first.pct}% off`
            : `Add ${remaining} ${itemWord} to unlock ${first.pct}% off your set`;
          return;
        }
        this.checkoutBtn.textContent =
          this.checkoutBtn.dataset.checkoutLabel || 'ADD SET TO CART';
      }

      _handleCartShippingUpdate(event) {
        if (!this.isConnected) return;
        const detail = event?.detail || {};
        const requestState = detail.requestState;
        if (requestState?.responseData?.ok === false) return;
        const body = requestState?.responseData?.body;
        const cart = typeof detail.cart?.total_price === 'number'
          ? detail.cart
          : (typeof body?.total_price === 'number' ? body : null);
        if (cart) {
          this.cartTotalCents = cart.total_price;
          this._syncShippingMessage();
          return;
        }
        this._fetchCartTotal();
      }

      _fetchCartTotal() {
        const token = (this._cartReadToken = (this._cartReadToken || 0) + 1);
        const xhr = new XMLHttpRequest();
        xhr.open('GET', `${shopifyRoot()}cart.js`, true);
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.onload = () => {
          if (token !== this._cartReadToken || !this.isConnected) return;
          if (xhr.status < 200 || xhr.status >= 300) return;
          try {
            const fresh = JSON.parse(xhr.responseText);
            if (typeof fresh.total_price === 'number') {
              this.cartTotalCents = fresh.total_price;
              this._syncShippingMessage();
            }
          } catch {
            /* ignore */
          }
        };
        xhr.send();
      }

      _syncShippingMessage() {
        const el = this.shippingEl;
        if (!el) return;
        const enabled = el.dataset.shippingEnabled === 'true';
        const threshold = Number.parseFloat(el.dataset.shippingThreshold) || 0;
        const thresholdCents = Math.round(threshold * 100);
        const totalCents = (this.cartTotalCents || 0) + (this._bundleFinalCents || 0);
        const unlocked = enabled && thresholdCents > 0 && totalCents >= thresholdCents;
        const icon = el.querySelector('[data-bundle-set-shipping-icon]');
        const label = el.querySelector('[data-bundle-set-shipping-label]');
        el.classList.toggle('bundle-set__shipping--unlocked', unlocked);
        if (icon) icon.toggleAttribute('hidden', !unlocked);
        if (!label) return;
        if (unlocked) {
          label.innerHTML = `You've unlocked <strong>Free Shipping</strong>`;
          return;
        }
        if (totalCents <= 0) {
          label.innerHTML = `<strong>Free Shipping</strong> on orders over <strong>${this.formatMoney(thresholdCents)}</strong>`;
          return;
        }
        const remainingCents = enabled && thresholdCents > 0
          ? Math.max(0, thresholdCents - totalCents)
          : 0;
        label.innerHTML = `You're just <strong>${this.formatMoney(remainingCents)}</strong> away from <strong>Free Shipping</strong>`;
      }

      _syncSetUpsells(qtySum, hasItems) {
        if (!this.upsellsEl) return;
        const inSetIds = new Set(
          this.miniSetLines
            .map((line) => String(line.productId))
            .filter((id) => id && id !== 'NaN'),
        );
        let visibleCount = 0;
        const maxVisible = 3;
        for (const card of this.upsellCards) {
          const productId = card.getAttribute('data-product-id') || '';
          const inSet = inSetIds.has(productId);
          const show = !inSet && visibleCount < maxVisible;
          if (show) visibleCount += 1;
          card.toggleAttribute('hidden', !show);
        }
        this.upsellsEl.toggleAttribute('hidden', !(hasItems && visibleCount > 0));
        if (this.upsellsHeadingEl) {
          this.upsellsHeadingEl.textContent = this.buildUpsellHeading(qtySum);
        }
      }

      _handleSetUpsellAdd(btn) {
        if (!btn || this._checkoutLoading) return;
        const productId = Number.parseInt(btn.getAttribute('data-product-id'), 10);
        if (!Number.isFinite(productId)) return;

        const card = this.querySelector(
          `[data-bundle-browse-card][data-product-id="${productId}"]`,
        );
        if (!card) return;

        this.openQuickView(card, { fromUpsell: true });
      }
  
      _conditionsFromMiniSetLines() {
        const qtySum = this.getLineQuantitySum();
        const byProduct = new Map();
        for (const line of this.miniSetLines) {
          if (this._showGiftFreeLine(qtySum) && this._isGiftVariant(line.variantId)) continue;
          const pid = line.productId;
          if (!Number.isFinite(pid)) continue;
          byProduct.set(pid, (byProduct.get(pid) || 0) + line.quantity);
        }
        return [...byProduct.entries()]
          .map(([p, q]) => `${p}@${q}`)
          .join('+');
      }
  
      _lineCartTitle(line) {
        const vt = (line.variantTitle || '').trim();
        if (vt && vt !== 'Default Title') return vt;
        return line.title || '';
      }
  
      async _addMiniSetToCart() {
        if (this._checkoutLoading || !this.miniSetLines.length) return;
        if (!this.cartDiscountKey) return;
        if (!this._meetsCheckoutMin(this.getLineQuantitySum())) return;

        this._checkoutLoading = true;
        this.classList.add('bundle-builder--checkout-loading');
        if (this.checkoutBtn) {
          if (!this.checkoutBtn.dataset.originalLabel) {
            this.checkoutBtn.dataset.originalLabel =
              this.checkoutBtn.dataset.checkoutLabel || this.checkoutBtn.textContent;
          }
          this.checkoutBtn.textContent = 'ADDING.....';
          this.checkoutBtn.disabled = true;
        }
        this.querySelectorAll('[data-bundle-set-qty]').forEach((b) => {
          b.disabled = true;
        });

        let addFailed = false;
        try {
          // One native ajax-cart add with all lines as individual items (no _bundle_id).
          const byVariant = new Map();
          for (const line of this.miniSetLines) {
            if (this._isGiftVariant(line.variantId)) continue;
            const prev = byVariant.get(line.variantId);
            if (prev) prev.quantity += line.quantity;
            else byVariant.set(line.variantId, { ...line });
          }

          const addItems = [...byVariant.values()].map((line) => ({
            id: line.variantId,
            quantity: line.quantity,
            properties: {
              _d: this.cartDiscountKey,
              _title: this._lineCartTitle(line),
            },
          }));

          const qtySum = this.getLineQuantitySum();
          if (
            this._isGiftUnlocked(qtySum) &&
            this._hasGiftProduct() &&
            !this.miniSetLines.some((l) => this._isGiftVariant(l.variantId))
          ) {
            addItems.push({
              id: this.giftVariantId,
              quantity: 1,
              properties: {
                _d: this.cartDiscountKey,
                _title: this._giftCartTitle(),
                _gift: '1',
                _free_gift: 'true',
              },
            });
          }

          if (!addItems.length) throw new Error('Empty set');

          await new Promise((resolve, reject) => {
            if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === 'function') {
              window.liquidAjaxCart.add(
                { items: addItems },
                {
                  info: { initiator: 'bundle-builder' },
                  lastCallback: (requestState) => {
                    if (requestState?.responseData?.ok) {
                      resolve(requestState);
                      return;
                    }
                    const body = requestState?.responseData?.body;
                    reject(
                      new Error(
                        (typeof body?.description === 'string' && body.description)
                          || (typeof body?.message === 'string' && body.message)
                          || 'Add to cart failed',
                      ),
                    );
                  },
                },
              );
              return;
            }

            if (typeof window.JR?.addSetThenOpen === 'function') {
              window.JR.addSetThenOpen(addItems).then(resolve).catch(reject);
              return;
            }

            reject(new Error('Cart unavailable'));
          });

          this.cartTotalCents = (this.cartTotalCents || 0) + (this._bundleFinalCents || 0);
          this.miniSetLines = [];
          this._bundleFinalCents = 0;
          if (this._miniSetMobileMq?.matches) {
            this._hideMobileMiniSetPeek();
          } else {
            this._closeMobileMiniSetUi();
          }

          // liquidAjaxCart.add already re-rendered drawer sections in the add response.
          window.dispatchEvent(new CustomEvent('cart-open'));
          this._fetchCartTotal();

          if (window.cartModel && typeof window.cartModel.fetch === 'function') {
            window.cartModel.fetch(undefined, true);
          }
        } catch (err) {
          addFailed = true;
          if (this.checkoutBtn) {
            const original = this.checkoutBtn.dataset.originalLabel || this.checkoutBtn.textContent;
            if (!this.checkoutBtn.dataset.originalLabel) {
              this.checkoutBtn.dataset.originalLabel = original;
            }
            this.checkoutBtn.textContent =
              (err && err.message) ? `RETRY — ${err.message}` : 'TRY AGAIN';
            window.clearTimeout(this._ctaErrorResetTimer);
            this._ctaErrorResetTimer = window.setTimeout(() => {
              if (this.checkoutBtn && this.checkoutBtn.dataset.originalLabel) {
                this.checkoutBtn.textContent = this.checkoutBtn.dataset.originalLabel;
                delete this.checkoutBtn.dataset.originalLabel;
              }
            }, 4000);
          }
        } finally {
          this._checkoutLoading = false;
          this.classList.remove('bundle-builder--checkout-loading');
          if (!addFailed) {
            if (this.checkoutBtn && this.checkoutBtn.dataset.originalLabel) {
              this.checkoutBtn.textContent = this.checkoutBtn.dataset.originalLabel;
              delete this.checkoutBtn.dataset.originalLabel;
            }
            this._renderMiniSet({ instantMilestones: true });
          } else {
            this.querySelectorAll('[data-bundle-set-qty]').forEach((b) => {
              b.disabled = false;
            });
            this._syncCheckoutButton(this.getLineQuantitySum());
          }
        }
      }
  
      _closeMobileMiniSetUi() {
        this.classList.remove('bundle-builder--set-open');
        const closeBtn = this.querySelector('[data-bundle-set-mobile-close]');
        if (closeBtn) closeBtn.setAttribute('aria-label', 'Expand set');
        if (document.body.dataset.bundleBuilderScrollLock === '1') {
          document.documentElement.style.overflow = '';
          document.documentElement.classList.remove('overflow-hidden');
          delete document.body.dataset.bundleBuilderScrollLock;
        }
      }
  
      _hideMobileMiniSetPeek() {
        if (!this._miniSetMobileMq?.matches) return;
        if (this.getLineQuantitySum() > 0) {
          this._closeMobileMiniSetUi();
          return;
        }
        this._mobilePeekDismissed = true;
        this._closeMobileMiniSetUi();
        this.classList.remove('bundle-builder--set-empty');
        this.classList.remove('bundle-builder--set-peek');
        if (this.miniSetAside) this.miniSetAside.setAttribute('aria-hidden', 'true');
      }
  
      _dismissMobileMiniSetBackdrop() {
        if (!this._miniSetMobileMq?.matches) return;
        if (this.getLineQuantitySum() < 1) {
          this._hideMobileMiniSetPeek();
          return;
        }
        if (this.classList.contains('bundle-builder--set-open')) {
          this._closeMobileMiniSetUi();
          return;
        }
        if (this.classList.contains('bundle-builder--set-peek')) {
          this._hideMobileMiniSetPeek();
        }
      }
  
      _openMobileMiniSetUi() {
        if (!this._miniSetMobileMq || !this._miniSetMobileMq.matches) return;
        const qty = this.getLineQuantitySum();
        if (qty < 1 && !this.classList.contains('bundle-builder--set-empty')) return;
        this.classList.add('bundle-builder--set-open');
        const closeBtn = this.querySelector('[data-bundle-set-mobile-close]');
        if (closeBtn) closeBtn.setAttribute('aria-label', 'Collapse set');
        document.body.dataset.bundleBuilderScrollLock = '1';
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.classList.add('overflow-hidden');
      }
  
      _toggleMobileMiniSetExpanded() {
        if (!this._miniSetMobileMq || !this._miniSetMobileMq.matches) return;
        if (this.getLineQuantitySum() < 1) {
          this._hideMobileMiniSetPeek();
          return;
        }
        if (this.classList.contains('bundle-builder--set-open')) {
          this._closeMobileMiniSetUi();
          return;
        }
        this._openMobileMiniSetUi();
      }
  
      _syncMobileMiniSetChrome() {
        const mobile = this._miniSetMobileMq && this._miniSetMobileMq.matches;
        const qty = this.getLineQuantitySum();
        if (!mobile) {
          this._closeMobileMiniSetUi();
          this.classList.remove('bundle-builder--set-peek');
          this.classList.remove('bundle-builder--set-empty');
          if (this.miniSetAside) this.miniSetAside.removeAttribute('aria-hidden');
          return;
        }
        const cartWasVisible =
          this.classList.contains('bundle-builder--set-peek') ||
          this.classList.contains('bundle-builder--set-open');
  
        if (qty > 0) {
          this.classList.remove('bundle-builder--set-empty');
          this.classList.add('bundle-builder--set-peek');
          if (this.miniSetAside) this.miniSetAside.setAttribute('aria-hidden', 'false');
        } else if (cartWasVisible && !this._mobilePeekDismissed) {
          this.classList.add('bundle-builder--set-peek');
          this.classList.add('bundle-builder--set-empty');
          this.classList.add('bundle-builder--set-open');
          if (this.miniSetAside) this.miniSetAside.setAttribute('aria-hidden', 'false');
          const closeBtn = this.querySelector('[data-bundle-set-mobile-close]');
          if (closeBtn) closeBtn.setAttribute('aria-label', 'Collapse set');
          document.body.dataset.bundleBuilderScrollLock = '1';
          document.documentElement.style.overflow = 'hidden';
          document.documentElement.classList.add('overflow-hidden');
        } else {
          this._mobilePeekDismissed = false;
          this.classList.remove('bundle-builder--set-peek');
          this.classList.remove('bundle-builder--set-empty');
          this._closeMobileMiniSetUi();
          if (this.miniSetAside) this.miniSetAside.setAttribute('aria-hidden', 'true');
        }
      }
  
      parseCount(raw) {
        const n = Number.parseInt(String(raw), 10);
        return Number.isFinite(n) ? n : 0;
      }
  
      formatItemsLine(n) {
        const productCount = this.parseCount(n);
        if (productCount === 1) return '1 ITEM';
        return `${productCount} ITEMS`;
      }
  
      clearSetSelection() {
        for (const setTabButton of this.setTabButtons) {
          setTabButton.setAttribute('aria-selected', 'false');
          setTabButton.tabIndex = -1;
        }
      }
  
      getActiveMainTab() {
        return (
          this.mainTabButtons.find((tabButton) => tabButton.getAttribute('aria-selected') === 'true') ??
          this.mainTabButtons[0]
        );
      }
  
      _urlSetSlug() {
        try {
          const slug = new URLSearchParams(window.location.search).get('set');
          return slug ? String(slug).trim().toLowerCase() : '';
        } catch {
          return '';
        }
      }
  
      _getPreselectedSetTab() {
        return this.setTabButtons.find((t) => t.getAttribute('aria-selected') === 'true') || null;
      }
  
      _resolveSetTabFromUrl() {
        const slug = this._urlSetSlug();
        if (!slug || !this.setTabButtons.length) return null;
        for (const setTab of this.setTabButtons) {
          const panelId = (setTab.getAttribute('data-bundle-products-panel') || '').trim().toLowerCase();
          if (!panelId) continue;
          if (panelId === slug || panelId === `set-${slug}`) return setTab;
          if (panelId.startsWith('set-') && panelId.slice(4) === slug) return setTab;
        }
        return null;
      }
  
      _setSlugFromSetTab(setTab) {
        const panelId = (setTab?.getAttribute('data-bundle-products-panel') || '').trim();
        if (panelId.startsWith('set-')) return panelId.slice(4);
        return panelId;
      }
  
      _setQueryHref(slug) {
        const params = new URLSearchParams(window.location.search);
        if (slug) params.set('set', slug);
        else params.delete('set');
        const qs = params.toString();
        return qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
      }
  
      _pushPageUrl(href) {
        const current = window.location.pathname + window.location.search;
        if (current === href) return;
        window.history.pushState(null, null, href);
        window.dispatchEvent(new Event('theme:history:sync'));
      }
  
      _syncUrlSetParam(setTab) {
        const slug = this._setSlugFromSetTab(setTab);
        if (!slug) return;
        this._pushPageUrl(this._setQueryHref(slug));
      }
  
      _clearUrlSetParam() {
        if (!new URLSearchParams(window.location.search).has('set')) return;
        this._pushPageUrl(this._setQueryHref(''));
      }
  
      _applySetFromUrl({ updateUrl = true } = {}) {
        const preselectedSetTab = this._getPreselectedSetTab();
        const urlSetTab = this._resolveSetTabFromUrl();
        if (urlSetTab && urlSetTab !== preselectedSetTab) {
          this.selectSetTab(urlSetTab, { updateUrl });
        } else if (preselectedSetTab) {
          this.syncCountAndTitle();
          this.syncProductPanels();
        } else if (!urlSetTab) {
          this.selectMainTab(this.getActiveMainTab(), { updateUrl });
        }
      }
  
      syncProductPanels() {
        if (!this.productPanels.length) return;
        const activeMainTab = this.getActiveMainTab();
        const mainId = activeMainTab?.dataset.bundleMainId;
        let panelId = mainId;
        if (mainId === 'all') {
          const activeSetTab = this.setTabButtons.find(
            (setTabButton) => setTabButton.getAttribute('aria-selected') === 'true',
          );
          panelId =
            activeSetTab?.getAttribute('data-bundle-products-panel') || 'all';
        }
        for (const panel of this.productPanels) {
          const id = panel.getAttribute('data-bundle-products-panel');
          if (id === panelId) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        }
      }

      syncCountAndTitle() {
        const activeMainTab = this.getActiveMainTab();
        const activeSetTab = this.setTabButtons.find(
          (setTabButton) => setTabButton.getAttribute('aria-selected') === 'true',
        );
        const isAllMain = activeMainTab?.dataset.bundleMainId === 'all';
        if (isAllMain && activeSetTab) {
          this.countOutput.textContent = this.formatItemsLine(activeSetTab.dataset.productCount);
          return;
        }
        this.countOutput.textContent = this.formatItemsLine(activeMainTab?.dataset.productCount);
      }
  
      _scrollToBuildProducts() {
        const target = this.buildHeadEl || this.buildViewPanel;
        if (!target || typeof target.scrollIntoView !== 'function') return;
        // Let the heading / count / discount / filtered grid paint in place
        // FIRST, then scroll. A double rAF guarantees one painted frame of the
        // updated (un-scrolled) content, so the dynamic bits don't appear to
        // change mid-travel.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            try {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } catch {
              target.scrollIntoView();
            }
          });
        });
      }

      enterSetFilter(cta) {
        if (!cta) return;
        const targetId = (cta.getAttribute('data-bundle-set-target') || '').trim();
        if (!targetId) return;
        const escaped =
          typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function'
            ? window.CSS.escape(targetId)
            : targetId;
        const panel = this.querySelector(`[data-bundle-products-panel="${escaped}"]`);
        if (!panel) return;

        this._activeSetPanelId = targetId;

        // Show only the selected set's products in the builder grid.
        for (const p of this.productPanels) {
          p.toggleAttribute('hidden', p.getAttribute('data-bundle-products-panel') !== targetId);
        }

        // Category tabs don't apply while a curated set is pinned.
        if (this.mainTabsWrap) this.mainTabsWrap.setAttribute('hidden', '');

        // Heading -> set name.
        const name = cta.getAttribute('data-bundle-set-name') || '';
        if (this.titleEl && name) this.titleEl.textContent = name;

        // Quantity -> set item count.
        const count = cta.getAttribute('data-bundle-set-count');
        if (this.countOutput && count != null) {
          this.countOutput.textContent = this.formatItemsLine(count);
        }

        // Discount hint -> "ADD ALL {n}, UNLOCKS {pct}% OFF".
        const pct = Number.parseInt(cta.getAttribute('data-bundle-set-pct'), 10);
        const countNum = Number.parseInt(count, 10);
        if (this.discountBadgeEl) {
          if (Number.isFinite(pct) && pct > 0) {
            const qtyLabel = Number.isFinite(countNum) ? countNum : count;
            this.discountBadgeEl.innerHTML =
              `<span class="bundle-builder__discount-lead">ADD ALL ${qtyLabel}</span>` +
              `<span class="bundle-builder__discount-sep" aria-hidden="true">&middot;</span>` +
              `<span class="bundle-builder__discount-unlock">UNLOCKS ${pct}% OFF</span>`;
            this.discountBadgeEl.removeAttribute('hidden');
          } else {
            this.discountBadgeEl.setAttribute('hidden', '');
          }
        }

        // Reveal the "Shop All" back control.
        if (this.setBackBtn) this.setBackBtn.removeAttribute('hidden');

        this._syncActiveSetUi();
        this._scrollToBuildProducts();
      }

      _resetSetFilterUi() {
        if (!this._activeSetPanelId) return;
        this._activeSetPanelId = null;
        if (this.mainTabsWrap) this.mainTabsWrap.removeAttribute('hidden');
        if (this.discountBadgeEl) this.discountBadgeEl.setAttribute('hidden', '');
        if (this.setBackBtn) this.setBackBtn.setAttribute('hidden', '');
        if (this.titleEl) this.titleEl.textContent = this._defaultBuildHeading;
        const allTab =
          this.mainTabButtons.find((tab) => tab.dataset.bundleMainId === 'all') || this.mainTabButtons[0];
        if (allTab) {
          for (const tabButton of this.mainTabButtons) {
            const isActive = tabButton === allTab;
            tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
            tabButton.tabIndex = isActive ? 0 : -1;
          }
        }
        this.clearSetSelection();
        this.syncCountAndTitle();
        this.syncProductPanels();
        this._syncActiveSetUi();
      }

      // Reflects the pinned curated set across the page: its card gets an
      // active outline. With no set pinned, the footer lists every set (both
      // tabs). When a set is pinned it cross-sells the others plus SHOW ALL.
      _syncActiveSetUi() {
        const activeId = this._activeSetPanelId;
        for (const card of this.setCards) {
          const target = card.querySelector('[data-bundle-set-shop]')?.getAttribute('data-bundle-set-target');
          card.classList.toggle('is-active', Boolean(activeId) && target === activeId);
        }
        if (!this.setsFooterEl) return;
        const showAllSets = !activeId;
        this.setsFooterEl.classList.toggle('bundle-footer_wrapper--all-sets', showAllSets);
        let shown = 0;
        for (const btn of this.setsFooterButtons) {
          const isActive = Boolean(activeId) && btn.getAttribute('data-bundle-set-target') === activeId;
          btn.toggleAttribute('hidden', isActive);
          if (!isActive) shown += 1;
        }
        if (shown === 0) {
          this.setsFooterEl.setAttribute('hidden', '');
          return;
        }
        if (this.setsFooterHeadingEl) {
          this.setsFooterHeadingEl.textContent = showAllSets
            ? 'NOT SURE WHERE TO START?'
            : 'MORE FROM BOBBI';
        }
        if (this.setsFooterSubheadingEl) {
          const countWord = SETS_FOOTER_COUNT_WORDS[shown] || String(shown);
          const countLabel = showAllSets ? countWord.toLowerCase() : countWord;
          // "up to" is the promo's best tier, not the best of the listed sets.
          const maxPct = Number.parseInt(this.setsFooterEl.dataset.bundleMaxPct, 10);
          const savings =
            Number.isFinite(maxPct) && maxPct > 0
              ? ` — <span class="bundle-footer_savings">save <strong>up to ${maxPct}%</strong></span>`
              : '';
          this.setsFooterSubheadingEl.innerHTML = showAllSets
            ? `Bobbi's ${countLabel} ready made set${shown === 1 ? '' : 's'}${savings}`
            : `${countWord} more ready-made set${shown === 1 ? '' : 's'}${savings}`;
        }
        this.shopAllWrap?.toggleAttribute('hidden', showAllSets);
        this.shopAllBtn?.toggleAttribute('hidden', showAllSets);
        this.setsFooterEl.removeAttribute('hidden');
      }

      selectView(view) {
        if (!view || !this.viewTabButtons || !this.viewTabButtons.length) return;
        // Leaving the curated-set filter whenever the top-level view changes.
        this._resetSetFilterUi();
        for (const btn of this.viewTabButtons) {
          const isActive = btn.getAttribute('data-bundle-view') === view;
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
          btn.tabIndex = isActive ? 0 : -1;
        }
        for (const panel of this.viewPanels) {
          const id = panel.getAttribute('data-bundle-view-panel');
          // The curated-sets tab keeps the custom builder visible below it;
          // the build tab shows the builder only.
          const show = view === 'sets' ? id === 'sets' || id === 'build' : id === view;
          panel.toggleAttribute('hidden', !show);
        }
        this._syncActiveSetUi();
        requestAnimationFrame(() => {
          this._syncMainTabsScrollHint?.();
        });
      }

      selectMainTab(activeMainTab, { updateUrl = true } = {}) {
        for (const tabButton of this.mainTabButtons) {
          const isActive = tabButton === activeMainTab;
          tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tabButton.tabIndex = isActive ? 0 : -1;
        }
        this.clearSetSelection();
        this.setsRegion?.removeAttribute('data-bundle-sets-hidden');
        this.syncCountAndTitle();
        this.syncProductPanels();
        if (updateUrl) this._clearUrlSetParam();
        requestAnimationFrame(() => this._syncMainTabsScrollHint?.());
      }
  
      selectSetTab(activeSetTab, { updateUrl = true } = {}) {
        const activeMainTab = this.getActiveMainTab();
        if (activeMainTab.dataset.bundleMainId !== 'all') {
          const allTab = this.mainTabButtons.find((tab) => tab.dataset.bundleMainId === 'all');
          if (allTab) {
            for (const tabButton of this.mainTabButtons) {
              const isActive = tabButton === allTab;
              tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
              tabButton.tabIndex = isActive ? 0 : -1;
            }
          }
        }
        for (const setTabButton of this.setTabButtons) {
          const isActive = setTabButton === activeSetTab;
          setTabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
          setTabButton.tabIndex = isActive ? 0 : -1;
        }
        if (this.setSwiper && this._setSwiperMq?.matches) {
          const idx = this.setTabButtons.indexOf(activeSetTab);
          if (idx >= 0 && this.setSwiper.activeIndex !== idx) {
            this._setSwiperFromSelect = true;
            this.setSwiper.slideTo(idx);
            this._setSwiperFromSelect = false;
          }
        }
        this.syncCountAndTitle();
        this.syncProductPanels();
        if (updateUrl) this._syncUrlSetParam(activeSetTab);
      }
    }
  
    customElements.define('bundle-builder', BundleBuilder);
  })();
  